/**
 * Database helpers - no circular dependencies
 * Separated from connection.tsx to avoid circular dependency with localstorage
 */
import db from ".";

export const createRef = (collection: any, docId: string) =>
  db.doc(`${collection}/` + docId);
